var Markdown = require('react-native-easy-markdown').default;

exports._markdown = Markdown;
